module.exports = __webpack_public_path__ + "media/images/bg-beagrumb-d2ecf9c7.jpg";